import { useState } from "react";
import { usePideFiado } from '../../../hooks/usePideFiado';
import { useNavigate } from "react-router-dom";

export const usePaymentMethodScreen = () => {

    const route = useNavigate();

    const [paymentMethod, setPaymentMethod] = useState([]);

    const {
        addProduct,
        getFiadoProduct,
        getPaymentMethod
    } = usePideFiado();


    const [error, setError] = useState({
        title: "",
        message: "",
        active: false
    })

    const nextScreen = (productId, amount, originCurrency, destinationCurrencyId, navigation, idFiadoFlash, exchangeRateId) => {

        //console.log(productId);

        if (productId == 'PAYMENT_METHOD_CHECK_USD') {
            addProduct(productId, 'paymentMethod')
            route('/CheckScreen', {state:{
                productId,
                transferredAmount: amount,
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            })
        }

        if (productId == 'PAYMENT_METHOD_CARD_USD') {
            addProduct(productId, 'paymentMethod')
            route('/BillScreen', {state:{
                originCurrencyId: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                exchangeRateId: exchangeRateId,
                amount: amount}
            })
        }
        
        if (productId == 'PAYMENT_METHOD_CARD_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/BillScreen', {state:{
                originCurrencyId: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                exchangeRateId: exchangeRateId,
                amount: amount}
            })
        }

        if (productId == 'CASHOUT_BANK_ACCOUNT_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/Cashout/BankAccount', {state:{
                productId,
                transferredAmount: amount,
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            });

        }

        if (productId == 'CASHOUT_IN_MERCHANT_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/BankScreen', {state:{
                productId,
                transferredAmount: amount}
            })
        }

        if (productId == 'PAYMENT_METHOD_IN_BANK_ACCOUNT_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/BankPaymentScreen', {state:{
                productId,
                transferredAmount: amount,
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            });
        }

        if (productId == 'PAYMENT_METHOD_IN_STORE_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/StorePaymentScreen', {state:{
                productId,
                transferredAmount: amount,
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            })
        }



        if (productId == 'PAYMENT_METHOD_IN_STORE_QR_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/ArcusPaymentScreen', {state:{
                productId,
                transferredAmount: parseInt(amount),
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            })
        }

        if (productId == 'CASHOUT_IN_STORE_QR_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/ArcusPaymentScreen', { state:{
                productId,
                transferredAmount: parseInt(amount),
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            })
        }

        if (productId == 'PAYMENT_METHOD_IN_ZELLE') {
            addProduct(productId, 'paymentMethod')
            route('/ZellePaymentScreen', {state:{
                productId,
                transferredAmount: amount,
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            })
        }

        if (productId == 'PAYMENT_METHOD_CODI_QR_MXN') {
            addProduct(productId, 'paymentMethod')
            route('/CodiPaymentScreen', {state:{ 
                productId,
                transferredAmount: amount,
                originCurrency: originCurrency,
                destinationCurrencyId: destinationCurrencyId,
                idFiadoFlash: idFiadoFlash}
            })
        }
 


        // if (productId == 'PAYMENT_METHOD_IN_STORE_MXN') {
        //     addProduct(productId, 'paymentMethod')
        //     route('RequestBankPaymentScreen', {
        //         productId,
        //         transferredAmount: amount,
        //         originCurrency: originCurrency,
        //         destinationCurrencyId: destinationCurrencyId,
        //         idFiadoFlash: idFiadoFlash
        //     })
        // }

        // if (productId == 'PAYMENT_METHOD_IN_STORE_MXN') {
        //     addProduct(productId, 'paymentMethod')
        //     route('RequestZellePaymentScreen', {
        //         productId,
        //         transferredAmount: amount,
        //         originCurrency: originCurrency,
        //         destinationCurrencyId: destinationCurrencyId,
        //         idFiadoFlash: idFiadoFlash
        //     })
        // }

    }



    return {
        paymentMethod,
        setError,
        nextScreen,
        setPaymentMethod
    }
}